import { TimeDiff } from './types';

export function calcTimeDiff(target: string | Date, now: Date = new Date()): TimeDiff {
  const targetDate = typeof target === 'string' ? new Date(target) : target;
  const totalMs = targetDate.getTime() - now.getTime();
  const isPast = totalMs <= 0;
  const absMs = Math.abs(totalMs);

  const seconds = Math.floor((absMs / 1000) % 60);
  const minutes = Math.floor((absMs / (1000 * 60)) % 60);
  const hours = Math.floor((absMs / (1000 * 60 * 60)) % 24);
  const days = Math.floor(absMs / (1000 * 60 * 60 * 24));

  return { days, hours, minutes, seconds, totalMs, isPast };
}

export function getNextYearlyOccurrence(dateStr: string, now: Date = new Date()): string {
  const target = new Date(dateStr);
  const thisYear = new Date(
    now.getFullYear(),
    target.getMonth(),
    target.getDate(),
    target.getHours(),
    target.getMinutes(),
    target.getSeconds()
  );

  if (thisYear.getTime() > now.getTime()) {
    return thisYear.toISOString();
  }

  const nextYear = new Date(
    now.getFullYear() + 1,
    target.getMonth(),
    target.getDate(),
    target.getHours(),
    target.getMinutes(),
    target.getSeconds()
  );
  return nextYear.toISOString();
}

export function getEffectiveTarget(event: { targetDate: string; repeatYearly: boolean }, now: Date = new Date()): string {
  if (!event.repeatYearly) return event.targetDate;
  const diff = calcTimeDiff(event.targetDate, now);
  if (!diff.isPast) return event.targetDate;
  return getNextYearlyOccurrence(event.targetDate, now);
}

export function formatTimePart(n: number): string {
  return String(n).padStart(2, '0');
}

export function getUrgencyLevel(totalMs: number): 'critical' | 'urgent' | 'soon' | 'relaxed' {
  const hours = totalMs / (1000 * 60 * 60);
  if (hours <= 1) return 'critical';
  if (hours <= 24) return 'urgent';
  if (hours <= 72) return 'soon';
  return 'relaxed';
}
